import { CircleDollarSign, MapPin, Timer, Zap } from "lucide-react";

type GatewayContainerProps = {
  name: string;
  country: string;
  lifetime: string;
  currency: string;
  status: string;
  bgColor?: string;
  logo?: React.ReactNode;
};

export default function GatewayContainer({
  name,
  country,
  lifetime,
  currency,
  status,
  bgColor = "#F3CBCB",
  logo,
}: GatewayContainerProps) {
  return (
    <div
      className="w-[240px] flex flex-col items-start justify-center rounded-lg p-4"
      style={{ backgroundColor: bgColor }}
    >
      <div className="w-full flex items-start justify-between">
        <div className="flex flex-col items-start justify-start gap-y-2 text-black text-sm">
          <p>{name}</p>

          <div className="flex items-center gap-x-2">
            <MapPin size={16} />
            <p>{country}</p>
          </div>

          <div className="flex items-center gap-x-2">
            <Timer size={16} />
            <p>{lifetime}</p>
          </div>

          <div className="flex items-center gap-x-2">
            <CircleDollarSign size={16} />
            <p>{currency}</p>
          </div>

          <div className="flex items-center gap-x-2">
            <Zap size={16} />
            <p>{status}</p>
          </div>
        </div>

        <div className="rounded-lg h-16 w-16 bg-white flex items-center justify-center">
          {logo}
        </div>
      </div>

      <button className="w-full bg-background rounded-lg p-2 text-white mt-4">
        Modify Gateway
      </button>
    </div>
  );
}
